import store from "@/store/index";
import { Message, MessageBox } from "element-ui";
import { getUrlArgObject } from "@/utils/spilturl";

// 设置webToekn
function setWebToken(status) {
  var UrlObj = getUrlArgObject();
  if (UrlObj.token) {
    localStorage.setItem("token", UrlObj.token);
    localStorage.setItem("app_id", UrlObj.id || UrlObj.appid);
    store.commit("SET_TOKEN", UrlObj.token);
    store.commit("SET_APPID", UrlObj.id || UrlObj.appid);
  } else if (localStorage.getItem("token")) {
    store.commit("SET_TOKEN", localStorage.getItem("token"));
    store.commit("SET_APPID", localStorage.getItem("app_id"));
  } else if (status == "test") {
    store.commit("SET_TOKEN", "7d3667426b4f957a1e98f8d0361721d2");
    store.commit("SET_APPID", "389");
    localStorage.setItem("token", "7d3667426b4f957a1e98f8d0361721d2");
    localStorage.setItem("app_id", "389");
  }
  // if(localStorage.getItem("app_id") == '393'){
  //   MessageBox.alert('服务已过期，业务需求请联系加油站', '提示', {
  //     confirmButtonText: '确定',
  //     callback: action => {
  //       localStorage.removeItem("token");
  //       if(localStorage.getItem('baseStatus') == "test"){
  //         window.location.href = "https://cs.58zltc.com/#/login?redirect=%2Fmanage%2Fcenter";
  //       }else if(localStorage.getItem('baseStatus') == "online"){
  //         window.location.href = "https://www.58zltc.com/#/login?redirect=%2Fmanage%2Fcenter";
  //       }
  //     }
  //   });
  // }
}

export { setWebToken };
